<template>
  <div class="column full-height">
    <!-- Header with Search (Floating Mode Only) -->
    <TemplateListHeader
      v-if="isFloating"
      v-model:search-query="searchQuery"
      v-model:show-filters="showFilters"
      v-model:filter-config="filterConfig"
      @close="$emit('close')"
    />

    <!-- Search + Filter (Normal Mode) -->
    <div
      v-if="!isFloating"
      class="row q-col-gutter-md items-center q-px-2x-md q-pt-md"
    >
      <!-- Search Row -->
      <div class="row items-center col-7">
        <PInput
          v-model="searchQuery"
          placeholder="Search by template name"
          outlined
          clearable
          class="full-width"
        >
          <template #prepend>
            <SearchIcon class="icon--sm text-neutral-50" />
          </template>
        </PInput>
      </div>

      <!-- Filter Dropdown -->
      <div class="col-5">
        <PSelectInput
          v-model="selectedTag"
          :options="categoryOptions"
          placeholder="Select option"
          label="Tag"
          label-position="side"
          label-classes="q-mt-xxs"
          dense
          outlined
          clearable
        />
      </div>
    </div>

    <!-- List -->
    <div class="col overflow-auto" :class="listContainerClass">
      <TemplateList :loading="loading" :templates="filteredTemplates" />
    </div>
  </div>
</template>

<script setup>
import SearchIcon from "src/assets/icons/search.svg";

const { isFloating } = inject("floating-chat-dialog", {});

defineEmits(["close"]);

const { templates } = storeToRefs(useChatStore());
const { getMessageTemplates } = useChatStore();

const searchQuery = ref("");
const selectedTag = ref("");
const loading = ref(false);
const showFilters = ref(false);

const categoryOptions = computed(() => {
  const categories = templates.value.map((t) => t?.category).filter(Boolean);

  return [...new Set(categories)].map((c) => ({
    label: c.charAt(0).toUpperCase() + c.slice(1).toLowerCase(),
    value: c,
  }));
});

// Configuration for header component (search + filter)
const filterConfig = computed({
  get: () => ({
    enabled: true,
    searchPlaceholder: "Search by template name",
    options: categoryOptions.value,
    selected: selectedTag.value,
    label: "Tag",
    placeholder: "Select option",
  }),
  set: (value) => {
    selectedTag.value = value.selected;
  },
});

// Computed class based on isFloating
const listContainerClass = computed(() =>
  unref(isFloating) ? "q-px-md q-py-sm" : "q-px-2x-md q-py-md",
);

const filteredTemplates = computed(() => {
  return templates.value.filter((t) => {
    const matchesSearch = searchQuery.value
      ? t?.elementName
          ?.replaceAll("_", " ")
          .toLowerCase()
          .includes(searchQuery.value.toLowerCase())
      : true;

    const matchesTag = selectedTag.value
      ? t?.category === selectedTag.value
      : true;

    return matchesSearch && matchesTag;
  });
});

watchEffect(async () => {
  loading.value = true;

  await getMessageTemplates();

  loading.value = false;
});
</script>
